import { Injectable } from '@angular/core';
import { AuthConfig, NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { filter } from 'rxjs/operators';
import { AppConfigService } from '../../app-config/app-config.service';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthConfigService {

  private _accessToken: string;
  private _IdToken: string;
  private tokenReceived = new Subject();
  private currentUser:string;
    constructor(
      private readonly oauthService: OAuthService,
      // private readonly authConfig: AuthConfig,
      private appConfigService: AppConfigService,

    ) {}


    get accessToken() { 
      return this._accessToken; 
    }
  
    get IdToken() { 
      return this._IdToken; 
    }

    initAuth(): Promise<any> {
      return new Promise<void>((resolveFn, rejectFn) => {
        this.setRedirectURL();
        let authConfig  : AuthConfig =  this.appConfigService.getConfig().identity;
        // setup oauthService
        authConfig.redirectUri = this.getRedirectURL();
        this.oauthService.configure(authConfig);
        this.oauthService.setStorage(sessionStorage);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();

        // subscribe to token events
        this.oauthService.events
          .pipe(filter((e: any) => {
            return e.type === 'token_received';
          }))
          .subscribe(() => this.handleNewToken());

        this.oauthService.loadDiscoveryDocumentAndLogin().then(isLoggedIn => {
          if (isLoggedIn) {
            this.oauthService.setupAutomaticSilentRefresh();
            resolveFn();
          } else {
            this.oauthService.initImplicitFlow();
            rejectFn();
          }
        });

      });
    }

    /**
     * Save new token
     */
    private handleNewToken() {
      this._accessToken = this.oauthService.getAccessToken();
      this._IdToken = this.oauthService.getIdToken();
      this.setTokenDetails(this._IdToken);
      // this.resetRedirectURL();
    }

    /**
     * Check token validity
     */
    hasValidAccessToken():boolean{
      return this.oauthService.hasValidAccessToken();
    }

    /**
     * Logout from auth service
     */
    logout(){
      sessionStorage.removeItem('access_token');
      this.resetRedirectURL(this.appConfigService.getConfig().identity.postLogoutRedirectUri);
      return this.oauthService.logOut();
    }


    /**
     * Token observer
     */
    getTokenDetails(){
      return this.tokenReceived.asObservable();
    }
  
    setTokenDetails(val:string){
      this.tokenReceived.next(this.oauthService.getIdentityClaims());
    }

    /**
     * Decoded session storage
     */
    getSessionStorage(){
      return this.oauthService.getIdentityClaims();
    }

    /**
     * Get redirect url
     * @returns URL
     */
    getRedirectURL(){
      const urlFromSession = sessionStorage.getItem('last_redirect_url');
      if(urlFromSession) 
        return urlFromSession;
      else 
        return window.location.href;
    }
 
    /**
     * Set Redirect URL
     */
    setRedirectURL(){
      sessionStorage.setItem('last_redirect_url', this.getRedirectURL());
    }

    /**
     * Reset redirect URL
     */
    resetRedirectURL(url:string = ''){
      sessionStorage.setItem('last_redirect_url', url);
    }

    setLastLoggedUser(profileName: string) {
      sessionStorage.setItem('last_logged_user', profileName);
    }
  
    getLastLoggedUser() {
      return sessionStorage.getItem('last_logged_user');
    }
  }
